<template>
    <div class="report__list">
        <div class="report__list_header">
            <view-actions
                :title="$t('ebs.reports.title.reports')"
                :cancel-button-active="false"
                :submit-button-active="allowCreateReport"
                :submit-button-text="'Create report'"
                @emit-submit="redirectToReportBuilder"
            />
        </div>
        <div class="report__list_main">
            <template v-if="user.isTokenFromNewLms()">
                <component-list
                    :component-table="ReportListTable"
                    :component-table-name="'reports'"
                    :empty-state-title="'Reports will appear here. Go ahead and create one by clicking Create report.'"
                    :get-items-getter="'getEbsReportsDefinedReports'"
                    :get-items-dispatch="'ebsReportsGetDefinedReports'"
                    :item-name="['report', 'reports']"
                />
            </template>
            <template v-else>
                <report-list-grid
                    :report-slugs="['events', 'sessions']"
                    :report-titles="[this.$t('ebs.reports.title.events'), this.$t('ebs.reports.title.sessions')]"
                />
            </template>
        </div>
    </div>
</template>

<script>
import ReportListGrid from '@/components/ebs/reports/list/ReportListGrid'
import ViewActions from '@/components/default/shared/ViewActions'
import { User } from '@/User'
import ComponentList from '@/components/default/shared/ComponentList'
import ReportListTable from '@/components/ebs/reports/list/ReportListTable'
export default {
  name: 'report-list',
  components: { ComponentList, ViewActions, ReportListGrid },
  data () {
    return {
      user: new User(),
      ReportListTable
    }
  },
  computed: {
    allowCreateReport () {
      return (
        (
          this.user.isTokenFromNewLms() &&
      this.user.hasAnyCustomerService(['LMS']) &&
      (
        this.user.isSuperadmin() ||
      this.user.isMasterAdministrator() ||
      this.user.isLearningExperienceAdministrator()
      )
        ) ||
      (
        this.user.isTokenFromNewLms() &&
      this.user.hasAnyCustomerService(['EBS']) &&
      (
        this.user.isSuperadmin() ||
      this.user.isMasterAdministrator() ||
      this.user.isEventCoordinator()
      )
      )
      )
    }
  },
  methods: {
    redirectToReportBuilder () {
      this.$router.push({ name: 'ebs-report-builder-add' })
    }
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/ebs/reports/reportlist";
</style>
